import AppStateModel from './../../../model/appStateModel';

export default class LifespanModel {

    private static _knob_rotation: any;

    static set knob_rotation(rotation) {
        LifespanModel._knob_rotation = rotation;
    }

    static get knob_rotation() {
        return LifespanModel._knob_rotation;
    }

    static getResultsByBirthdayAndGender(birthday = AppStateModel.birthday, gender = AppStateModel.gender, resultMap = AppStateModel.birthdayMap) {

        return AppStateModel.getResultsByBirthdayAndGender(birthday, gender, resultMap);
    }
}
